module.exports = __webpack_public_path__ + "static/img/gamify.3ff9934.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logos/gamify.svg
// module id = l5Ih
// module chunks = 13